export default {
  'exp.sql.start.time': {
    ko: '시작 일시',
    en: 'Start time',
  },
  'exp.sql.inst': {
    ko: '인스턴스',
    en: 'Instance',
  },
  'exp.sql.mandt': {
    ko: 'Client ID.',
    en: 'Client ID.',
  },
  'exp.sql.account': {
    ko: '사용자 ID.',
    en: 'User ID.',
  },
  'exp.sql.cmpnt.type': {
    ko: '컴포넌트 유형',
    en: 'Component type',
  },
  'exp.sql.cmpnt.nm': {
    ko: '컴포넌트 명',
    en: 'Component name',
  },
  'exp.sql.app.src': {
    ko: '소스 라인',
    en: 'Source line',
  },
  'exp.sql.status': {
    ko: '상태',
    en: 'Status',
  },
  'exp.sql.err.code': {
    ko: '에러 코드',
    en: 'Error code',
  },
  'exp.sql.operation': {
    ko: '오퍼레이션',
    en: 'Operation',
  },
  'exp.sql.respti': {
    ko: 'R.T.',
    en: 'R.T.',
  },
  'exp.sql.cpu.time': {
    ko: 'CPU time',
    en: 'CPU time',
  },
  'exp.sql.mem.size': {
    ko: '메모리 사용량',
    en: 'Memory size',
  },
  'exp.sql.records': {
    ko: '레코드 건수',
    en: 'Number of records',
  },
  'exp.sql.lw.count': {
    ko: '누적 Lock 건수',
    en: 'Lock wait count',
  },
  'exp.sql.re.mem.size': {
    ko: '재사용 메모리',
    en: 'Reused memory size',
  },
  'exp.sql.lw.duration': {
    ko: 'Lock 시간',
    en: 'Lock duration',
  },
  'exp.sql.transid': {
    ko: '트랜잭션 ID.',
    en: 'Transaction ID.',
  },
  'exp.sql.parameters': {
    ko: 'SQL 패러미터',
    en: 'SQL parameters',
  },
  'exp.sql.command': {
    ko: 'SQL 문',
    en: 'SQL statement',
  },
  'exp.sql.cmpnt.type.C': {
    ko: 'Dialog',
    en: 'Dialog',
  },
  'exp.sql.cmpnt.type.B': {
    ko: 'Batch',
    en: 'Batch',
  },
  'exp.sql.cmpnt.type.T': {
    ko: 'RFC/CPIC',
    en: 'RFC/CPIC',
  },
  'exp.sql.cmpnt.type.S': {
    ko: 'Spool',
    en: 'Spool',
  },
  'exp.sql.cmpnt.type.V': {
    ko: 'Update(V1/V2)',
    en: 'Update(V1/V2)',
  },
  'exp.sql.cmpnt.type.U': {
    ko: 'Update(server)',
    en: 'Update(server)',
  },
  'exp.sql.cmpnt.type.O': {
    ko: 'Outbound',
    en: 'Outbound',
  },
  'exp.sql.cmpnt.type.I': {
    ko: 'Inbound',
    en: 'Inbound',
  },
  'exp.sql.cmpnt.type.': {
    ko: 'Unknown',
    en: 'Unknown',
  },
};
